import { render, staticRenderFns } from "./CaseloadManager.vue?vue&type=template&id=1c98272f&scoped=true&"
import script from "./CaseloadManager.vue?vue&type=script&lang=js&"
export * from "./CaseloadManager.vue?vue&type=script&lang=js&"
import style0 from "./CaseloadManager.vue?vue&type=style&index=0&id=1c98272f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c98272f",
  null
  
)

export default component.exports